export default "__VITE_ASSET__DyMk68_6__"